import React from 'react';
import { SAVED_FILTER_PROPS, SAVED_FILTER_STATE } from './Types';
import { Component } from '../../../dispatcher/modules';
import HBox from '../../layout/container/h_box/HBox';
import PuzzleButton from '../../UI/button/PuzzleButton';
import { Position } from '../../../dispatcher/Types';
import PuzzleDropDownButton from '../../UI/button/dropdown/PuzzleDropDownButton';
import { DropDownButtonItemClickEvent } from '@progress/kendo-react-buttons';
import _ from 'lodash';
import { encodeHtmlCharacters } from '../../../utility';

/**
 * @class SavedFilter
 * Saved filter component
 */
class SavedFilter extends Component<SAVED_FILTER_PROPS, SAVED_FILTER_STATE> {
  state: SAVED_FILTER_STATE = {
    filterColor: '#FFFFFF',
    filterName: 'NA',
    filterParams: []
  }

  constructor(props: SAVED_FILTER_PROPS) {
    super(props);
    this.state = {
      ...this.state,
      ...props
    };
  }

  /**
   * On delete event trigger delete request
   * Params should be filterName and url
   */
  onDelete = () => {
    this.dispatch('DeleteFilterFlow', {
      pos: Position.end,
      persistent: ['filterName', 'url', 'name']
    }, {
      name: encodeHtmlCharacters(this.props.filterName),
      filterName: this.props.filterName,
      url: _.get(this, 'props.endPoints.filters')
    });
  }

  /**
   * Trigger filters
   * Sends filters as params to the request
   */
  triggerFilter = () => {
    this.dispatch('ApplyFilter', '', {
      ...this.state
    });
  }

    /**
     * Event filter click loads the current saved filter into the form
     * @param event
     */
    onFilterClick = (event) => {
      if (this.props.onClick) {
        this.props.onClick(event, this.props.filterParams);
      }
      else if (!event.target?.firstChild?.classList?.contains('tp-icon') && !event.target?.classList?.contains('k-menu-link-text')) {
        this.dispatch('LoadFilter', Position.end, {
          ...this.state
        });
      }
    }

  /**
   * Executes on click of clone filter button
   */
  private onCloneClick = () => {
    this.dispatch('CloneFilter', Position.end, {
      ...this.state
    });
  }

    /**
     * Filter action event will trigger one on many actions presented to the user
     * Currently CLONE and DELETE are presented to a user
     * @param event
     */
    onFilterAction = (event: DropDownButtonItemClickEvent) => {
      let action = _.get(event, 'item.actionName');
      if (action) {
        switch (action) {
          case 'clone':
            this.onCloneClick();
            break;
          case 'delete':
            this.onDelete();
            break;
        }
      }
    }

    /**
     * @override
     */
    renderBody() {
      const {
        filterColor,
        filterName
      } = this.state;
      return (
        <div
          className={'saved-filter'}
          onClick={this.onFilterClick}
          tabIndex={0}
          key={this.props.key}
        >
          <HBox
            alignItemsCenter
            justifyContentBetween
          >
            <HBox
              alignItemsCenter
            >
              <span
                className={'saved-filter-colors'}
                style={{
                  backgroundColor: filterColor
                }}
              />
              <span
                className={'saved-filter-title'}
              >{filterName}</span>
            </HBox>
            <div
              className={'saved-filter-btns k-display-flex'}
            >
              <PuzzleButton
                aria-label={this.translate('SRL-applyFilter', {
                  filterName: filterName
                })}
                size={'small'}
                fillMode={'flat'}
                iconClass={'tp-icon tp-filterNew'}
                onClick={this.triggerFilter}
                titleText={this.translate('Apply filter')}
                tooltipPosition={'top'}
                withTooltip
              />
              <PuzzleDropDownButton
                size={'small'}
                fillMode={'flat'}
                iconClass={'tp-icon tp-icon tp-more-vertical k-rotate-90'}
                onItemClick={this.onFilterAction}
                items={[{
                  text: this.translate('cloneFilter'),
                  actionName: 'clone'
                }, {
                  text: this.translate('deleteFilter'),
                  actionName: 'delete'
                }]}
              />
            </div>
          </HBox>
        </div>
      );
    }
}

export default SavedFilter;
